var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnplug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.832 17.1666L73.832 7.16663",
    stroke: "#3E3E3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69701 69.3167L15.58 61.6491",
    stroke: "#3E3E3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9018 66.7978C19.4711 67.6835 20.2097 68.4481 21.0752 69.0478C21.9406 69.6474 22.916 70.0704 23.9452 70.2923C24.9745 70.5142 26.0374 70.5308 27.0731 70.341C28.1088 70.1513 29.0968 69.7589 29.9805 69.1865L39.0909 63.308L23.7555 39.5419L14.6452 45.4204C13.7595 45.9898 12.9949 46.7283 12.3952 47.5938C11.7955 48.4593 11.3726 49.4346 11.1507 50.4639C10.9288 51.4931 10.9122 52.5561 11.102 53.5917C11.2917 54.6274 11.6841 55.6154 12.2565 56.4992L18.9018 66.7978Z",
    stroke: "#3E3E3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5913 45.4835L37.4938 39.0938",
    stroke: "#3E3E3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2592 57.3666L45.1618 50.9769",
    stroke: "#3E3E3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 20.5L60.5 40.5L68.1667 32.8333C68.9125 32.0901 69.5042 31.207 69.908 30.2345C70.3118 29.2621 70.5196 28.2196 70.5196 27.1667C70.5196 26.1137 70.3118 25.0712 69.908 24.0988C69.5042 23.1264 68.9125 22.2432 68.1667 21.5L59.5 12.8333C58.7568 12.0875 57.8736 11.4957 56.9012 11.092C55.9288 10.6882 54.8862 10.4803 53.8333 10.4803C52.7804 10.4803 51.7379 10.6882 50.7655 11.092C49.793 11.4957 48.9099 12.0875 48.1667 12.8333L40.5 20.5Z",
    stroke: "#3E3E3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnplug);
export default __webpack_public_path__ + "static/media/icon-unplug.4ace9d25b31ea3c9adc959d1d3259921.svg";
export { ForwardRef as ReactComponent };